import React, { Fragment, useEffect, useState } from "react";
import ReactDOM from "react-dom";
import app from "./data/base";
import "./index.scss";
import * as serviceWorker from "./serviceWorker";
import storedux from "./store/index";
import { Provider } from "react-redux";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import App from "./App";
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { routes } from "./router/route";
import ScrollToTop from "./component/common/ScrollToTop";
import Signin from "./auth/signin";
import { store } from 'react-role-permission';

import ConfigDB from "./data/customizer/config";
import { ToastContainer } from "react-toastify";
import HomePortal from "./portal/home";
import { UserActions } from "./store/user/user.action";
import AuthGate from "./app/auth/AuthGate";
import config from "./app/config";
import updateColorVar from "./utils/colors.utils";

const renderRoutes = (anim, embed = false) => (
  <TransitionGroup>
    {routes.map(({ path, Component }) => (
      <Route
        key={embed ? `embed-${path}` : path}
        exact
        path={`${process.env.PUBLIC_URL}${embed ? '/embed' : ''}${path}`}
      >
        {({ match }) => (
          <CSSTransition
            in={match != null}
            timeout={500}
            classNames={anim}
            unmountOnExit
          >
            <div>
              <Component />
            </div>
          </CSSTransition>
        )}
      </Route>
    ))}
    <ToastContainer />
  </TransitionGroup>
);

const Root = (props) => {
  const [anim, setAnim] = useState("");
  const animation = localStorage.getItem("animation") || ConfigDB.data.router_animation || 'fade';
  const abortController = new AbortController();
  const [currentUser, setCurrentUser] = useState(false);

  useEffect(() => {
    document.title = config.pageTitle;
  }, []);

  useEffect(() => {
    app.auth.onAuthStateChanged((isValid) => {
      console.log('onAuthStateChanged');
      storedux.dispatch(UserActions.setUser(isValid));
    });
    Object.entries(config.colors).forEach(([key, value]) => {
      updateColorVar(key, value);
    });
  }, []);

  useEffect(() => {
    // const color = localStorage.getItem('color')
    // document.getElementById("color").setAttribute("href", `${process.env.PUBLIC_URL}/assets/css/${color}.css`);
    setAnim(animation);
    app.auth.onAuthStateChanged(setCurrentUser, store);
    console.ignoredYellowBox = ["Warning: Each", "Warning: Failed"];
    console.disableYellowBox = true;
    return function cleanup() {
      abortController.abort();
    };
  }, [abortController, animation]);

  const finalview = (
    <Fragment>
      <Provider store={storedux}>
        <BrowserRouter basename={`/`}>
          <ScrollToTop />
          <Switch>
            <Route
              path={`${process.env.PUBLIC_URL}/portal`}
              component={HomePortal}
            />
            <Route
              path={`${process.env.PUBLIC_URL}/login`}
              component={Signin}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/dashboard`}
              render={() => {
                return (
                  <Redirect
                    to={`${process.env.PUBLIC_URL}/dashboard/default`}
                  />
                );
              }}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/embed`}
              render={() => {
                return (
                  <Redirect
                    to={`${process.env.PUBLIC_URL}/embed/portal`}
                  />
                );
              }} />
            <Route
              path={`${process.env.PUBLIC_URL}/embed/portal`}
              render={(props) => <HomePortal {...props} embed={true} />}
            />
            <Route
              path={`${process.env.PUBLIC_URL}/embed/login`}
              component={Signin}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/embed/dashboard`}
              render={() => {
                return (
                  <Redirect
                    to={`${process.env.PUBLIC_URL}/embed/dashboard/default`}
                  />
                );
              }}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/embed`}
              render={() => {
                return (
                  <Redirect
                    to={`${process.env.PUBLIC_URL}/embed/portal`}
                  />
                );
              }} />
            <Route
              path={`${process.env.PUBLIC_URL}/embed`}
              render={() => (
                <AuthGate>
                  <App embed={true}>
                    {renderRoutes(anim, true)}
                  </App>
                </AuthGate>
              )}
            />
            <AuthGate>
              <App>
                {renderRoutes(anim)}
              </App>
            </AuthGate>
          </Switch>
        </BrowserRouter>
      </Provider>
    </Fragment>
  );
  return finalview;


};
ReactDOM.render(<Root />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

